import { contactPolicy, type ContactPolicyContact } from "../contactPolicy";
import { messageRecord, type MessageKind } from "../schemas/messages";
import { evaluation, zodIssues, type ValidationIssue } from "./issues";

export interface MessageFacts {
  action?: "comms.send_sms" | "comms.send_email" | "audit";
  contact?: ContactPolicyContact | null;
  activeBooking?: boolean;
  recipientMismatch?: boolean;
  contactLeadMismatch?: boolean;
  contactBookingMismatch?: boolean;
  leadBookingMismatch?: boolean;
  checksComplete?: boolean;
}
export function validateMessage(record: Record<string, unknown>, facts: MessageFacts = {}) {
  const entity = { type: "message" as const, ...(typeof record.id === "string" ? { id: record.id } : {}) };
  const issues: ValidationIssue[] = [];
  const action = facts.action === "comms.send_sms" || facts.action === "comms.send_email" ? facts.action : null;
  const parsed = messageRecord.safeParse(record);
  if (!parsed.success) issues.push(...zodIssues(parsed.error.issues, entity, action ?? "message.save").map(issue => ({ ...issue, code: `message.${issue.fields[0] || "record"}_invalid` })));
  const add = (code: string, fields: string[], message: string) => issues.push({ code: `message.${code}`, kind: "error", entity, fields, message, blocks: ["message.save", "comms.send_sms", "comms.send_email"] });
  if (facts.contactLeadMismatch) add("contact_lead_mismatch", ["contactId", "leadId"], "contact does not belong to lead");
  if (facts.contactBookingMismatch) add("contact_booking_mismatch", ["contactId", "bookingId"], "contact does not belong to booking");
  if (facts.leadBookingMismatch) add("lead_booking_mismatch", ["leadId", "bookingId"], "lead does not belong to booking");
  if (action && record.kind !== "staff_alert") {
    if (facts.contact === null) add("contact_required", ["contactId"], "contact is required");
    else if (facts.recipientMismatch) add("recipient_mismatch", ["to"], "recipient must match the selected contact");
    if (facts.contact) {
      const policy = contactPolicy(facts.contact, action === "comms.send_sms" ? "sms" : "email", { kind: record.kind as MessageKind, templateKey: typeof record.templateKey === "string" ? record.templateKey : null, activeBooking: facts.activeBooking });
      if (!policy.allowed) add(policy.code, ["contactId"], policy.code);
    }
  }
  return evaluation(issues, facts.checksComplete ?? false);
}
